import React from "react";
import Header from "../../components/header/Header";
import ExternalLink from "../../components/links/externalLink/ExternalLink";
import styles from "./HomePage.module.css";

const HomePage = () => {
  const showNavigation = false;
  return (
    <div>
      <Header showNavigation={showNavigation} />
      <div className={styles.page}>
        <div className={styles["container-home-page"]}>
          <h1 className={styles.welcome}>Welcome to Adways Specsheets</h1>
          <h2>Our Rich Media technology </h2>
          <p>
            Adways has been developing innovative Rich Media technology for
            the web and in-app for years on which every creative runs. Our own
            technology is a software that makes it possible to produce all
            different formats properly, to place them on websites and in apps,
            and to make them measurable everywhere. We are happy to help you
            with templates, formats, support, and ad serving with this
            technology.
          </p>
          <h2>Advanced Rich Media templates</h2>
          <p>
            We have HTML5 templates available for almost all Rich Media formats
            that are being produced that form the basis for every Rich Media
            campaign production. They can be used by every Rich Media developer
            with a coding background and always include technical support from
            our experienced team.
          </p>
          <p>
            All templates ensure proper functioning on the sites and devices for
            which they are made. Our own technology has already been
            incorporated into the HTML elements, which opens up numerous
            interactive and creative possibilities. Our templates are always
            available{" "}
            <ExternalLink link={"https://adways.com/en/contact"}>
              upon request.
            </ExternalLink>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
